import * as React from "react"
import {  any, Action, none, onlyIf, wait, loadingAsyncState, AsyncState, async, some, Option, IOWidget } from 'widgets-for-react'
import { fromJSX, SimpelPage } from '../../../../utils'
import { EventOverviewLayout } from "./eventOverview.layout"
import { Map } from "immutable"
import { WordPress } from "../../../wordpress/wordpress_api"


export interface EventOverviewPageState {
    events: Map<number, AsyncState<SimpelPage<WordPress.PostTypeResponse>>>
    total_pages: Option<number>
    size: number
    current_page: number
}

export const mk_EventOverviewPageState: EventOverviewPageState = {
    events: Map(),
    current_page: 1,
    size: 99,
    total_pages: none()
}

export const eventOverviewWidget: IOWidget<EventOverviewPageState ,Action<EventOverviewPageState>> = (s0) => {
    return any<Action<EventOverviewPageState>>()([

        onlyIf(s0.total_pages.v.kind == 'l' || s0.events.count() < s0.total_pages.v.v,
            wait<Action<EventOverviewPageState>>(500)(() => s1 => {
                let has_next = s1.total_pages.v.kind == 'l' || (s1.events.count() < s1.total_pages.v.v)
                if (!has_next) return s1

                return ({
                    ...s1,
                    events: s1.events.set(s1.current_page, loadingAsyncState(() =>
                        WordPress.api<WordPress.PostTypeResponse>().select('events')
                            .where({ page: s1.current_page, per_page: s1.size, _embed: true })
                            .getMultiple().then(data => {
                                if (data.status != 200) return ({ kind: 'failed', status: data.status })
                                return ({
                                    kind: 'result', status: data.status, value: {
                                        items: data.data,
                                        total_pages: Number(data.headers["x-wp-totalpages"]),
                                        total_items: Number(data.headers["x-wp-total"]),
                                        page_size: s1.size,
                                        current_page: s1.current_page
                                    }
                                })
                            }))),
                })
            })
        ),

        any<Action<Map<number, AsyncState<SimpelPage<WordPress.PostTypeResponse>>>>>()(

            s0.events.keySeq().map(k =>
                async<SimpelPage<WordPress.PostTypeResponse>>()(s0.events.get(k))
                    .map(a => (s) => s.set(k, a(s.get(k))))
            ).toArray()

        ).map(a => s1 => {
            let newData = a(s1.events)
            let first_entry = newData.get(1)
            return ({
                ...s1,
                events: newData,
                total_pages: first_entry != null && first_entry.kind == 'loaded' ? some(first_entry.value.total_pages) : none(),
                current_page: first_entry != null && first_entry.kind == 'loaded' ? s1.current_page + 1 : s1.current_page
            })
        }),

        fromJSX(setState => <EventOverviewLayout
            isLoading={s0.events.count() == 0 || s0.events.reduce<boolean>((xs, x) => xs && x.kind != 'loaded', true)}
            events={s0.events.toIndexedSeq()
                .toArray()
                .reduce((xs, x) => x.kind == 'loaded' ? xs.concat(x.value.items) : xs, Array<WordPress.PostTypeResponse>())
                .filter((x: any) => x.acf.event_date != undefined && new Date(x.acf.event_date).getTime() > Date.now())
                .sort((a: any, b: any) => new Date(a.acf.event_date).getTime() - new Date(b.acf.event_date).getTime())
            }
        />)
    ])
}
